<template>
  <div
    v-show="get_options.show_probability_chart"
    class="prob_detail"
  >
    <div class="prob_chart_page_header">
      <div class="header_content">
        <div class="header_content_title">各縣市放假機率時間軸</div>
          <img
            class="color_bar"
            src="@/assets/imgs/ty_prob_colorbar.png"
            style="width: 30%"
          >
      </div>

      <div>
        <button
          class="btn_close"
          @click="close_prob_detail()"
        >
          <i class="icon-close icon_size"></i>
        </button>
      </div>
    </div>

    <div
      class="chart_container"
    >
      <div id="prob_chart"></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'
import { TyProbColor } from '@/components/typhoon_tw/settings'
import * as ty_prob_chart from '@/assets/js/ty_prob_chart'

export default {
  data () {
    return {
      chart: null,
      dt_from: null,
      dt_to: null,
      chart_counties: [
        '基隆市', '臺北市', '新北市', '桃園市', '新竹市', '新竹縣', '苗栗縣', '臺中市', '彰化縣',
        '南投縣', '雲林縣', '嘉義縣', '臺南市', '高雄市', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣',
        '金門縣', '澎湖縣', '連江縣'
      ]
    }
  },

  computed: {
    ...mapGetters({
      get_options: types.GET_OPTIONS,
      get_typhoon_probability: types.GET_TYPHOON_PROBABILITY
    }),
  },

  watch: {
    get_typhoon_probability: {
      handler() {
        this.dt_from = Date.dtgptime(this.get_options.selected_init_time_z).setTimezone(0).toLocal()
        let tau = this.get_prob_max_tau()
        this.dt_to = this.dt_from.addHours(tau)
        this.draw_chart()
      },
      deep: true
    },

    'get_options.show_probability_chart'(chart_display) {
      this.draw_chart()
    }
  },

  methods: {

    ...mapActions({
      set_options: types.SET_OPTIONS
    }),

    close_prob_detail() {
      this.set_options({'show_probability_chart': false})
    },

    get_data_artists() {

      let _datasets = {}
      for (let county of this.chart_counties) {
        let county_prob = []
        // 找出此縣市有機率的時間資料
        for (let data of this.get_typhoon_probability) {
          let prob = data.probability.filter(_prob => _prob.probability.hasOwnProperty(county))
          if (prob) {
              county_prob = county_prob.concat(prob)
          }
        }

        if (!_datasets.hasOwnProperty(county)) {
          _datasets[county] = []
        }

        for (let _county_prob_info of county_prob) {
          let init_time = Date.dtgptime(_county_prob_info.init_time).setTimezone(0).toLocal()
          let dtime = init_time.addHours(_county_prob_info.tau)
          // 先檢查之前有無push同樣的dtime，有重複的且機率值比較小，更新大的機率值
          let info = _datasets[county].find(data => data.x.valueOf() === dtime.valueOf())
          if (info && info.y < _county_prob_info.probability[county]) {
            info.y = _county_prob_info.probability[county]
          }
          else {
            _datasets[county].push({
              x: dtime,
              y: _county_prob_info.probability[county]
            })
          }
        }
      }

      let datasets = {}
      for (let county in _datasets) {
        datasets[county] = new ty_prob_chart.CountyDataArtist(
          _datasets[county],
          new ty_prob_chart.CountyPaint({
            color_table: TyProbColor,
            data_range: [this.dt_from, this.dt_to]
          })
        )
      }

      return datasets
    },

    get_chart_options() {
      let y_axis_width = 50
      let clip_width = document.getElementById('prob_chart').offsetWidth
      let canvas_width = 800

      if (canvas_width < clip_width - y_axis_width) {
        canvas_width = clip_width - y_axis_width
      }

      let axes_y = {}
      for (let num in this.chart_counties) {
        let county = this.chart_counties[num]

        let sign_div = document.createElement('div')
        sign_div.className = 'elem_sign'
        sign_div.innerHTML = county

        axes_y[county] = {
          data_range: 'auto',
          canvas_range: 20 + num * 30,
          paint: new ty_prob_chart.CountyAxisYPaint({
            tick_value_anchor: "middle",
            sign: sign_div
          }),
        }
      }

      return {
        clip_size: {
          width: clip_width,
          height: 580
        },
        canvas_size: {
          width: canvas_width,
          height: 695
        },
        axis_x: {
          data_range: [this.dt_from, this.dt_to],
          font_size: 16,
          position: 'top',
          paint: new ty_prob_chart.CountyAxisXPaint({
            tick_value_anchor: "center"
          }),
          style: {
            height: 55
          }
        },
        // axis_y: 共用的 y 軸設定，且因固定行首，只會有左側的 y 軸
        axis_y: {
          style: {
            width: y_axis_width
          }
        },
        // axes_y: 每種資料各自不同的 y 軸設定
        axes_y: axes_y
      }
    },

    draw_chart() {
      this.$nextTick(() => {
        if (this.get_options.show_probability_chart) {
          if (this.chart) {
            this.chart = null
            document.getElementById('prob_chart').innerHTML = ''
          }

          if (this.dt_from && this.dt_to) {
            let data_artists = this.get_data_artists()
            let chart_options = this.get_chart_options()
            this.chart = new ty_prob_chart.Chart(
              'prob_chart',
              data_artists,
              chart_options
            )
          }
        }
      })
    },

    get_prob_max_tau() {
      let ty_prob_tau = 0
      let default_tau = 72

      for (let ty_info of this.get_typhoon_probability) {
        if (ty_info.probability.length) {
          let _ty_prob = ty_info.probability[ty_info.probability.length - 1]
          if (_ty_prob.tau > ty_prob_tau) {
            ty_prob_tau = _ty_prob.tau
          }
        }
      }

      //萬一沒有任何一顆颱風侵襲台灣 get_typhoon_probaility會是[]就畫預設三天的chart
      if (ty_prob_tau === 0) {
        return default_tau
      }

      return ty_prob_tau
    },
  },

  mounted () {
  }
}

</script>

<style>
.icon_size {
  font-size: xx-large;
}

.btn_close {
  border-radius: 55%;
  padding: 5px 6px;
  border: 1px solid black;
}

.prob_detail {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(245, 245, 245, 1);
  z-index: 2001;
  padding: 20px;
}

.prob_chart_page_header {
  display: flex;
  justify-content: space-between;
}

.header_content {
  text-align: left;
}

.header_content_title {
  font-size: 18px;
  padding: 0 0 10px 0;
}


#prob_chart {
  width: 100%;
  overflow: scroll;
  position: relative;
}

.chart_container {
  width: 100%;
  min-width: 390px;
  height: calc(100% - 80px);
  margin: 10px 0;
  display: flex;
  border-radius: 10px;
  border: solid 1px rgb(206, 206, 206);
  overflow-y: auto;
}

.y_axis_space {
  height: 100%;
  border-right: 1px solid #cecece;
  background-color: rgb(247, 247, 247);
  position: sticky;
  left: 0;
  z-index: 4;
}

.axis_x_space {
  background-color: rgb(247, 247, 247);
  border-bottom: 1px solid #cecece;
  position: sticky;
  top: 0;
  z-index: 5;
}


.chart_text_div {
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  font-size: 12px;
  /* color: rgb(60, 60, 60); */
  cursor: default;
  z-index: 1;
  text-align: center;
  white-space:nowrap;
}

.elem_sign {
  text-align: center;
  font-size: 14px;
  position: absolute;
  width: 100%;
}

.left {
    right: 5px;
}
.right {
    left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/typhoon_tw/ProbabilityChart.vue